





















import {Vue, Component} from 'vue-property-decorator'

@Component
export default class Navigation extends Vue {

    private navigationNamespace = 'navigation/';

    /*
    * This one is quite complicated. Basically it simulates user surfing from beginning to the end of app.
    * The hard part is navigation guards sync with display of arrows.
    * When user goes forward or backwards - nav guards switching current active index of the page
    * and vue loads corresponding data according to active index from navigation module.
    * */

    get currentIndex(): number {
        return this.$store.getters[`${this.navigationNamespace}getCurrentIndex`];
    }

    get showLeftArrow(): boolean{
        return this.$store.getters[`${this.navigationNamespace}getLeftArrowVisible`](this.currentIndex);
    }

    get showRightArrow(): boolean{
        return this.$store.getters[`${this.navigationNamespace}getRightArrowVisible`](this.currentIndex);
    }

    get currentTitle(): string{
        return this.$store.getters[`${this.navigationNamespace}getCurrentTitle`](this.currentIndex);
    }

    get currentMessage(): string{
        return this.$store.getters[`${this.navigationNamespace}getCurrentDescription`](this.currentIndex);
    }

    get nextRoute(): string{
        return this.$store.getters[`${this.navigationNamespace}getNextRoute`](this.currentIndex);
    }

    get prevRoute(): string{
        return this.$store.getters[`${this.navigationNamespace}getPreviousRoute`](this.currentIndex);
    }

    backward() {
        this.$router.push(this.prevRoute)
    }

    forward(){
        this.$router.push(this.nextRoute);
    }

}
